module.exports = __webpack_public_path__ + "img/Corteva-Logo-all-white.30be6ffd.png";